<p class="user-display__comment">"{{ selectedUserData()?.comment }}"</p>
<div class="user-display">
  <div class="user-display__profile">
    <img
      class="user-display__avatar"
      [src]="selectedUserData()?.imgSrc"
      [alt]="selectedUserData()?.name"
    />

    @if (selectedUserData(); as user) {
      <div class="user-display__info">
        <h3 class="user-display__name">{{ user.name }}</h3>
        <p class="user-display__description">{{ user.title }}</p>
        <div class="user-display__rating">
          @for (star of getStarArray(user.score); track $index) {
            <app-icon [icon]="iconName.STAR" class="user-display__star" />
          }
        </div>
      </div>
    }
  </div>
  <div class="user-display__controls">
    <button
      class="user-display__btn user-display__btn--prev"
      (click)="handlePaginationChange('prev')"
      [disabled]="selectedUser() === 1"
    >
      <app-icon [icon]="iconName.ARROW_RIGHT_CIRCLE" />
    </button>

    <button
      class="user-display__btn"
      (click)="handlePaginationChange('next')"
      [disabled]="selectedUser() === userData().length"
    >
      <app-icon [icon]="iconName.ARROW_RIGHT_CIRCLE" />
    </button>
  </div>
</div>
